export default "__VITE_ASSET__D6E2L36J__"